import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, UserCheck, Users } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { MediaImage } from "@/components/Media";

export default function Following() {
  const navigate = useNavigate();
  const [rows, setRows] = useState(null);
  const load = () => api.get("/me/following").then((r) => setRows(r.data.creators)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);
  const unfollow = async (c) => {
    try {
      await api.delete(`/creators/${c.id}/follow`);
      toast.success(`Unfollowed ${c.display_name}`);
      load();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    }
  };
  return (
    <div data-testid="following-screen" className="px-5 pt-6">
      <header className="flex items-center gap-3">
        <button onClick={() => navigate(-1)} aria-label="Back" data-testid="following-back" className="text-[#a7a0af] hover:text-white"><ArrowLeft size={22} /></button>
        <h1 className="text-xl font-bold">Following</h1>
      </header>
      <p className="mt-1 text-xs text-[#a7a0af]">Creators you follow for free. Following doesn't unlock paid content.</p>
      {!rows && <p className="mt-6 text-sm text-[#a7a0af]">Loading…</p>}
      {rows?.length === 0 && (
        <div data-testid="following-empty" className="mt-6 rounded-2xl glass p-5 text-sm text-[#c7c1cf]">
          You aren't following anyone yet.
          <button onClick={() => navigate("/app/discover")} data-testid="following-discover" className="ml-1 text-[#c77dff] underline">Discover creators</button>
        </div>
      )}
      <ul className="mt-5 flex flex-col gap-3">
        {rows?.map((c) => (
          <li key={c.id} data-testid={`following-row-${c.handle}`} className="flex items-center gap-3 rounded-2xl glass p-3">
            <button onClick={() => navigate(`/app/c/${c.handle}`)} className="flex min-w-0 flex-1 items-center gap-3 text-left">
              <div className="h-12 w-12 shrink-0 overflow-hidden rounded-full ring-1 ring-[#a03cff]">
                {c.avatar_url || c.card_url ? <MediaImage url={c.avatar_url || c.card_url} className="h-full w-full object-cover" /> : <div className="h-full w-full bg-gradient-to-br from-[#6a00ff] to-[#d42be8]" />}
              </div>
              <div className="min-w-0">
                <p className="truncate text-sm font-semibold">{c.display_name}</p>
                <p className="flex items-center gap-1 text-[0.65rem] text-[#a7a0af]"><Users size={11} /> {c.follower_count} {c.follower_count === 1 ? "follower" : "followers"}</p>
              </div>
            </button>
            <button onClick={() => unfollow(c)} data-testid={`following-unfollow-${c.handle}`} className="flex items-center gap-1 rounded-full border border-[#a03cff] px-3 py-1.5 text-xs"><UserCheck size={12} /> Following</button>
          </li>
        ))}
      </ul>
    </div>
  );
}
